import { AuthProviderProps } from 'react-oidc-context'
import { routes } from '../shared/constants/routes'

const { OIDC_AUTHORITY_URL, OIDC_CLIENT_ID } = process.env

export const oidcConfig: AuthProviderProps = {
  authority: OIDC_AUTHORITY_URL as string,
  client_id: OIDC_CLIENT_ID as string,
  redirect_uri: `${window.location.origin}${routes.authCallback}`,
  // silent_redirect_uri: '', // TODO: ?
  scope: 'openid profile email buildflow_api',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname)
  }
}
